import { Button } from '@connected/ui/components/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@connected/ui/components/dropdown-menu';
import { MoreVertical, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { DistributionBoard } from '../utils/distribution-board-list-types';

import { useDeleteDistributionBoardMutation } from '../hooks/use-distribution-board-mutations';

export type DistributionBoardActionsProps = {
    distributionBoard: DistributionBoard;
    electricalProjectVersionId: string;
};

export function DistributionBoardActions({
    distributionBoard,
    electricalProjectVersionId,
}: DistributionBoardActionsProps) {
    const { t } = useTranslation('common');
    const { handleDelete, deleteDistributionBoardMutation } = useDeleteDistributionBoardMutation({
        electricalProjectVersionId,
    });

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    disabled={deleteDistributionBoardMutation.isPending}
                    onClick={e => e.stopPropagation()}
                >
                    <MoreVertical className="size-5" />
                    <span className="sr-only">Acties</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem
                    variant="destructive"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDelete({
                            electricalProjectDistributionBoardId: distributionBoard.ElectricalProjectDistributionBoardId!,
                        });
                    }}
                    disabled={deleteDistributionBoardMutation.isPending}
                >
                    <Trash2 className="size-4" />
                    {t('actions.general.delete')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
